// src/components/common/Card.jsx
import React from 'react';
import '../../styles/Card.css';

/**
 * Double-Bezel (Doppelrand) Interactive Card
 * Features:
 * - Machined outer shell with hairline border & ambient drop shadow
 * - Concentric inner core with 1px liquid glass edge reflection
 * - Optional hover kinetic lift
 */
export default function Card({
  children,
  className = '',
  interactive = false,
  onClick = null,
  header = null,
  footer = null,
  ...rest
}) {
  const shellClass = `card-shell ${interactive ? 'card-shell--interactive' : ''} ${className}`;

  return (
    <div
      className={shellClass}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
      {...rest}
    >
      <div className="card-core">
        {header && <div className="card-core__header">{header}</div>}
        <div className="card-core__body">{children}</div>
        {footer && <div className="card-core__footer">{footer}</div>}
      </div>
    </div>
  );
}
